import { render, staticRenderFns } from "./prosecutionList.vue?vue&type=template&id=f60e33ba&scoped=true"
import script from "./prosecutionList.vue?vue&type=script&lang=js"
export * from "./prosecutionList.vue?vue&type=script&lang=js"
import style0 from "./prosecutionList.vue?vue&type=style&index=0&id=f60e33ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60e33ba",
  null
  
)

export default component.exports